import { useEffect, useState } from "react";
import { LineChart } from "../line-chart";
import { queryInfluxDataList } from "@/api/influx/influx";
import { TimeValue } from "@/global/interface/time-value";
import { Transfer2DisplayScale } from "@/global/utils/unit-type";
import "./index.less"
import classNames from "classnames";
import { ReactComponent as CloseSvg } from "@/global/components/sensor-collection-data-panel/icons/close.svg"

interface Iprops {
    sensorId: number,
    symbol: string,
    type: string,
    unit: string,
    name: string,
    onClickClose: (e) => void
}

export default function ParamsDataPanel(props: Iprops) {
    const [dataList, setDataList] = useState<number[][]>([])

    useEffect(() => {
        if (!props.sensorId || !props?.symbol || !props?.type || !props?.unit || !props?.name) return
        generateActiveParamData()
    }, [props])

    const generateActiveParamData = () => {
        queryInfluxDataList(props.sensorId, props.symbol, props.type).then(res => {
            let valueList: TimeValue[] = res.data || []
            // 组合成数据
            let data = []
            for (let i = 0; i < valueList?.length; i++) {
                data.push([valueList[i].time, valueList[i].value * Transfer2DisplayScale(props.unit)])
            }
            setDataList(data)
        })
    }

    const getChartAxisXLabel = (value: number) => {
        const date = new Date(Number(value));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    const getChartAxisYLabel = (value: number) => {
        return parseFloat(value.toFixed(2)).toString()
    }

    return (
        <div className="params-data-panel-main">
            <div className="left-body">
                <div className="collection-title">
                    数据面板
                </div>
                <div className="param-list">
                    <div className={classNames({
                        "list-item": true,
                        "list-item-active": true
                    })}
                    >
                        {props.name}
                    </div>
                </div>
            </div>
            <div className="right-body">
                <div className="tab-area">
                    <CloseSvg className="close-btn" onClick={() => { props.onClickClose(false) }} />
                </div>
                <div className="data-chart">
                    <LineChart
                        lineData={dataList}
                        getAxisXLabel={getChartAxisXLabel}
                        getAxisYLabel={getChartAxisYLabel}
                        xLabel="时间"
                        toolTipXLabel="时间"
                        noBackground={true}
                        yLabel={props.unit}
                        toolTipYLabel={props.name}
                    />
                </div>
            </div>
        </div>
    )
}